module.exports = __webpack_public_path__ + "img/leadIntegrated.63050543.svg";